module.exports = __webpack_public_path__ + "img/jiQiRen4.4fc76c8d.png";